import React from "react";
import { styled } from "@mui/system";
import MUIFormControlLabel from "@mui/material/FormControlLabel";
import { FormControlLabelProps as FormControlLabelPropsMUI } from "@mui/material/FormControlLabel";
export interface FormControlLabelProps extends FormControlLabelPropsMUI {}

const FormControlLabelRoot = styled(MUIFormControlLabel, {
  name: "FormControlLabel",
  slot: "Root",
  overridesResolver: (props, styles) => []
})(({ theme }) => ({
  "&.MuiFormControlLabel-root .MuiTypography-root.MuiFormControlLabel-label": {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: 14
  }
}));

export const FormControlLabel = React.forwardRef<
  HTMLLabelElement,
  FormControlLabelProps
>(function FormControlLabel(props, ref) {
  return <FormControlLabelRoot ref={ref} {...props} />;
}) as React.FC<FormControlLabelProps>;
